import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-grievance',
  templateUrl: './exam-grievance.component.html',
  styleUrls: ['./exam-grievance.component.scss']
})
export class ExamGrievanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
